import { PrimeReactProvider } from "primereact/api";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { PermissionsProvider } from "./providers/PermissionsProvider";
import { LayoutProvider } from "./components/layout/context/layoutcontext";
import RouteConstant from "./constants/route.constants";
import { Suspense, lazy } from "react";
import AppLoading from "./components/app-loading/app-loading";
import Layout from "./components/layout/layout";
import AboutUs from "./components/layout/footer-notes/about-us";
import Privacy from "./components/layout/footer-notes/privacy-policy";
import ContactUs from "./components/layout/footer-notes/contact-us";
import ReturnPolicy from "./components/layout/footer-notes/return-policy";
import TermsAndConditions from "./components/layout/footer-notes/terms-conditions";
import RegisterTermsAndConditions from "./components/layout/footer-notes/terms-and-conditions-register";
import { PrivateRoute } from "./components/security/private-route";
import ViewAllProducts from "./components/admin/view-all-products";
import ShippingPolicy from "./components/layout/footer-notes/shipping-policy";
import ViewAllRouteCodes from "./components/route-codes/rote-codes";
import ViewAllCountry from "./components/Country/country";
import ViewAllStates from "./components/state/state";
import ViewAllCity from "./components/City/city";
import ViewAllCategory from "./components/category/category";
import ViewAllSubCategory from "./components/SubCategory/subCategory";
import AddArea from "./components/add-area/areaPincode";
import Countrydis from "./components/NewCountry/NewCountry/Countrydis";
import AddState from "./components/add-state/stateMain";
import AddDistrict from "./components/districtmaster/districtMain";
import AddAreaPincodeMain from "./components/Area&PincodeMasterData/areaPincode-main";
import Typedetails from "./components/ComplainstList/ComplaintList-Details";
import Typedetails1 from "./components/ComplaintType/type-details";
import ViewAllCategories from "./components/Complaint-Category/categories-details";
import Categorydetails from "./components/Complaint-Category/categories-details";
import ViewStatus from "./components/status-search/status-details";
import AddSubdistrict from "./components/Add-Subdistrict/subdistrictMain";
import CanceledOrderMain from "./components/canceledOrder/canceled-order-main";
import Packingorders from "./components/Packing-Orders/packing-orders";
import Binorders from "./components/View-Bin_orders/view-bin";
import CustomerReportMain from "./components/Customer-report/Customer-report-main"; 
import CustomerFollowUpMain from "./components/customer-FollowUP/CustomerFollowUp-main";
import Cashdeposite from "./components/cash-collection-report/cash-collection-report-list";
import DeliveryDetailsDatatable from "./components/Driver-DeliveryDetails/DeliveryDetailsDatatable";
import GenerateProductCode from "./components/Generate-Product-code/generate-product-code";
import AddVendor from "./components/Vendor/AddVendor";
 import VendorDataTable from "./components/Vendor/VendorDataTable";
import ProductSummary from "./components/Driver-DeliveryDetails/ProductSummary";
import Positems from "./components/POS/Pos-items";
import PosMovementMain from "./components/PosMovements/pos-movement-main";
import GSTSalesReportsList from "./components/GSTSalesReport/gst-sales-report-list";
import AssignExecutivePage from "./components/Assign-CustomerExecutive/Assign-Executive-main";
import GenerateInvoiceList from "./components/New-Generate-Invoice/new-generate-invoice-list";
import InternalComplaint from "./components/Complaint/InternalComplaint"; 
import ComplaintRegister from "./components/Complaint/ComplaintRegister";
import ComplaintMain from "./components/Complaint/ComplaintMain";
import ComplaintActionMain from "./components/Complaint/ComplaintActionMain";
import CustomerComplaintMain from "./components/Complaint/CustomerComplaintMain";
import CustomerServComplaintRegister from "./components/Complaint/CustomerServComplaintRegister";
import RawMaterialPurchaseForm from "./components/RawMaterials/RawMaterialspurchase1";
import RawMaterialHistoryMain from "./components/RawMaterials/RawMaterialHistory-Main";
import POSTargetMappingList from "./components/pos_TargetMapping/pos-target-mapping-list";
import { TreemapChart } from "./components/pos-repot-details/pos-repot-list"; 
import RoleAccessmain from "./components/Role-assignment/RoleAccessmain";
import RoleManagement from "./components/RoleCreation/RoleCreation-main";
import FeatureAccessMain from "./components/FeatureAccess/FeatureAccessmain";
import POSInventoryReport from "./components/POS/POS-Inventory-Report";
import DeliveryCashMain from "./components/delivery-cash/delivery-cash-main";
import TestReportGenerate from "./components/TestReport/TestReportGenerate";
import DeliveryAnalysis from "./components/Driver-DeliveryDetails/DeliveryAnalysis-list";
import RawMaterialsPage from "./components/RawMaterials/RawMaterial-main";
import TestReportsPage from "./components/TestReport/TestReportsPage";
import RawMaterialMainPage from "./components/RawMaterials/RawMaterials-List/RawMaterial-Main";
import RawMaterialsMainPage from "./components/RawMaterials/RawMaterials-List/RawMaterial-Main";
import StoreCashMain from "./components/delivery-storecash-collection/storecash-main";

import SalesReportTables from "./components/CustomerexecutiveSalesReport/CESalesReport";
import InvoicedByReportTable from "./components/CustomerexecutiveSalesReport/InvoicedBySales";
import InternalComplaintRegister from "./components/ComplaintInternal/InternalComplaintRegister";
import InternalComplaintMain from "./components/ComplaintInternal/InternalComplaintMain";
import InternalComplaintActionMain from "./components/ComplaintInternal/InternalComplaintActionMain";
import RawMaterialCategoriesMainPage from "./components/RawMaterials/RawMaterial-Categories/RawMaterialCategory-Main";
import CashReportMain from "./components/where-is-my-cash-report/cash-report-main";
import CEtargetMappingList from "./components/CSE-TargetMapping/CEtargetMapping-main";
import CECards from "./components/CustomerExecutive-Performance-Report1/CEPerformance-report1-main";
import AccountsCashMain from "./components/delivery-AccCash-collection/accounts-cash-main";
import OutwardChallanMain from "./components/Outward-Challan/OutwardChallan-main";
import CEDailyActivityReport from "./components/CustomerExecutive-Performance-Report1/CustomerExecutive-DailyAcitivity-repot";
import OrderSearchById from "./components/GeoMapSearch/OrderSearchById";
import RawmaterialInventoryMain from "./components/Raw-Materials-Inventory/raw-material-main";
import RawMaterialMovementMain from "./components/RawMaterial-Movements/RawMaterial-movement-main";
import OrderDeliveryStatus from "./components/orders/orderDeliverySummary";
import ViewAllChallanPage from "./components/View-All-Challan/ViewAllChallan-Datatable";
import DeliveryExecutivePerformance from "./components/DeliveryExecutiveperformance/DeliveryExecutivePerformance-main";
import RawMaterialReport from "./services/RawMaterials/RawMaterial-Report";   
import VehicleList from "./components/Vehicle-Details/Vehicle-List ";

const SignIn = lazy(() => import("./components/signin/signin-component"));
const ForgotPassword = lazy(
  () => import("./components/forget-password/forget-password")
);
const Setting = lazy(() => import("./components/setting/setting"));
const Register = lazy(() => import("./components/register/register"));
const AddOrEditAddress = lazy(
  () => import("./components/user-address/add-or-edit-address")
);
const OpenOrders = lazy(
  () => import("./components/openorders-address/open-order")
);
const AddOrEditAddressArea = lazy(
  () => import("./components/user-address/editonarea")
);
const AddAddress = lazy(
  () => import("./components/user-address/addresss")
);
const AllUserAddress = lazy(
  () => import("./components/user-address/all-address")
);
const DeliveryAddress=lazy( ()=>import("./components/DeliveryAddress/OrderSearch"));
const UserProfile = lazy(() => import("./components/profile/userprofile"));
const UserPassword = lazy(() => import("./components/profile/password"));
const OrderSummary = lazy(() => import("./components/orders/order-summary"));
const MyWishlist = lazy(() => import("./components/wish-list/my-wish-list"));
const NotFound = lazy(() => import("./components/not-found/not-found"));
const Cart = lazy(() => import("./components/basket/carts"));
const Payment = lazy(() => import("./components/payments/payment"));
const Measurement = lazy(() => import("./components/measurements/measurement"));
const Products = lazy(() => import("./components/products/products"));
const MySubscriptions = lazy(() => import("./components/UserSubscriptions/UserSubscriptionsPage"));

const CourierCharges = lazy(
  () => import("./components/courier-charges/courier-charges")
);
const CourierProvider = lazy(
  () => import("./components/courier-provider/courier-provider")
);
const UserPreferredDelivery = lazy(
  () => import("./components/user-preferred-delivery/user-delivery")
);
const Banners = lazy(() => import("./components/banners/banner"));
const ProductDetail = lazy(
  () => import("./components/product/single-product-details")
);
const OrderList = lazy(() => import("./components/orders/order-list"));
const MyOrderList = lazy(() => import("./components/my-order/my-order"));
const MyInvoices = lazy(() => import("./components/reports/order-list"));
const AssignRouteCode = lazy(
  () => import("./components/route-code/assign-route-code")
);
const GenerateInvoice = lazy(
  () => import("./components/invoices/generate-inv")
);
const EditUsers = lazy(() => import("./components/edit-users/edit-users"));
const CustomerAddress = lazy(
  () => import("./components/edit-address/edit-cust-address")
);
const CourierProviderList = lazy(
  () => import("./components/courier-provider/courier-provider-new")
);

const Geomap = lazy(
  () => import("./components/GeoMap/GoogleMapPage")
);

const Geomapsearch = lazy(
  () => import("./components/GeoMapSearch/OrderSearchById")
);

const MainGetwayRequest = lazy(
  () => import("./components/payment-getways/main-getway-request")
);
const MainGetwayResponse = lazy(
  () => import("./components/payment-getways/main-getway-response")
);
const viewAllRouteCodes = lazy(
  () => import("./components/route-codes/rote-codes")
);
const viewCountry = lazy(() => import("./components/Country/country"));
const ViewStates = lazy(() => import("./components/state/state"));
const EditAddresss = lazy(() => import("./components/user-address/addresss"))
const NewInvoiceList = lazy(() => import("./components/New-Invoice-Report/new-order-list"));
const OilProduction = lazy(() => import("./components/oilProduction/oilProductionmain"))
const OilProductionDataTable = lazy(() => import("./components/oilProduction/OilProductionLogs"))
const DesiriUsers = lazy(() => import("./components/desiriUsers/DesiriUserPage"))
const DesiriBulls = lazy(() => import("./components/desiriBulls/DesiriBullsPage"))
const DesiriGaana = lazy(() => import("./components/desiriGaana/DesiriGaanaPage"))
const DesiriRoles = lazy(() => import("./components/desiriRoles/DesiriRolesPage"))

const OilProduction1 = lazy(() => import("./components/oilProduction/oilProductionmain1"))
const OilProductionDataTable1 = lazy(() => import("./components/oilProduction/OilProductionLogs1"))
const OilProductionDataTable2 = lazy(() => import("./components/oilProduction/OilProductionLogs1DT2"))
// const OilProductionDataTable2 = lazy(() => import("./components/oilProduction/OilProductionDataTable2"))
const OilProductionSummaryReport = lazy(() => import("./components/oilProduction/SummaryReport"))
const BullStatistics = lazy(() => import("./components/oilProduction/bull-statistics/main"))


function App() {
  const emptyFunction = () => { };
  return (
    <>
      <Router>
        <PrimeReactProvider>
          <PermissionsProvider>
            <LayoutProvider>
              <Suspense fallback={<AppLoading />}>
                <Routes>
                  <Route
                    path="*"
                    element={<Navigate replace to={RouteConstant.products} />}
                  />
                  <Route
                    path={RouteConstant.paymentResponse}
                    element={<MainGetwayResponse />}
                  />
                  <Route
                    element={<PrivateRoute isAuthenticationRequired={true} />}
                  >
                    <Route element={<Layout />}>
                      <Route
                        path={RouteConstant.addEditAddress}
                        element={<AddOrEditAddress />}
                      />
                      <Route
                        path={RouteConstant.addAddress1}
                        element={<AddAddress />}
                      />
                      <Route
                        path={RouteConstant.addEditAddressAreaid}
                        element={<AddOrEditAddressArea />}
                      />
                      <Route
                        path={RouteConstant.editaddresssId}
                        element={<EditAddresss />}
                      />

                      <Route
                        path={RouteConstant.userAddresses}
                        element={<AllUserAddress />}
                      />

                      <Route
                        path={RouteConstant.AssignExecutive}
                        element={<AssignExecutivePage/>}
                      />

                      <Route
                        path={RouteConstant.profile}
                        element={<UserProfile />}
                      />
                      <Route
                        path={RouteConstant.orderSummary}
                        element={<OrderSummary />}
                      />
                      <Route
                        path={RouteConstant.orderList}
                        element={<OrderList />}
                      />
                      <Route
                        path={RouteConstant.myOrders}
                        element={<MyOrderList />}
                      />
                      <Route
                        path={RouteConstant.mySubscriptions}
                        element={<MySubscriptions />}
                      />
                      <Route
                        path={RouteConstant.CustomerComplaintMain}
                        element={<CustomerComplaintMain />}
                      />
                      <Route
                        path={RouteConstant.invoice}
                        element={<MyInvoices />}
                      />
                               <Route 
                        path={RouteConstant.AddNewVendor} 
                        element={<AddVendor />} 
                      />
                                            <Route 
                        path={RouteConstant.AllVendors} 
                        element={<VendorDataTable />} 
                      />
                      <Route 
                        path={RouteConstant.GenerateProductCode} 
                        element={<GenerateProductCode />} 
                      />
                     <Route
                        path={RouteConstant.TestReports}
                        element={<TestReportGenerate />}
                      />
                        <Route
                        path={RouteConstant.TestReporttest}
                        element={<TestReportsPage />}
                      />
                      <Route
                        path={RouteConstant.assignroutecode}
                        element={<AssignRouteCode />}
                      />
                      <Route
                        path={RouteConstant.generateInvoice}
                        element={<GenerateInvoice />}
                      />
                      <Route
                        path={RouteConstant.newGenerateInvoice}
                        element={<GenerateInvoiceList />}
                      />
                      <Route
                        path={RouteConstant.editUsers}
                        element={<EditUsers />}
                      />
                      <Route
                        path={RouteConstant.customerAddress}
                        element={<CustomerAddress />}
                      />
                      <Route
                        path={RouteConstant.wishList}
                        element={<MyWishlist />}
                      />
                      <Route
                        path={RouteConstant.userPassword}
                        element={<UserPassword isResetPasswordPage={false} />}
                      />

                      <Route
                        path={RouteConstant.payment}
                        element={<Payment />}
                      />
                      <Route
                        path={RouteConstant.banner}
                        element={<Banners />}
                      />
                      <Route
                        path={RouteConstant.measurement}
                        element={<Measurement />}
                      />
                      <Route
                        path={RouteConstant.courierCharges}
                        element={<CourierCharges />}
                      />

                      <Route
                        path={RouteConstant.courierProvider}
                        element={<CourierProvider />}
                      />
                      <Route
                        path={RouteConstant.userPreferredDelivery}
                        element={<UserPreferredDelivery />}
                      />
                      <Route
                        path={RouteConstant.packingOrders}
                        element={<Packingorders />}
                      />
                      <Route
                        path={RouteConstant.binOrders}
                        element={<Binorders />}
                      />
                      
                      <Route
                        path={RouteConstant.Geomap}
                        element={<Geomap />}
                      />
                      <Route
                        path={RouteConstant.Geomapsearch}
                        element={<OrderSearchById  />}
                      />
                      
                      <Route
                        path={RouteConstant.setting}
                        element={<Setting />}
                      />
                      <Route
                        path={RouteConstant.courierProviderList}
                        element={<CourierProviderList />}
                      />
                      <Route
                        path={RouteConstant.getwayProcess}
                        element={<MainGetwayRequest />}
                      />
                      <Route
                        path={RouteConstant.addArea}
                        element={<AddArea />}
                      />
                      <Route
                        path={RouteConstant.oilProduction}
                        element={<OilProduction />}
                      />
                      <Route
                        path={RouteConstant.oilProductiondatatable}
                        element={<OilProductionDataTable />}
                      />
                      <Route
                        path={RouteConstant.oilProduction1}
                        element={<OilProduction1/>}
                      />
                       <Route
                        path={RouteConstant.oilProductiondatatable1}
                        element={<OilProductionDataTable1 />}
                      />

                       <Route
                        path={RouteConstant.oilProductiondatatable2}
                        element={<OilProductionDataTable2 />}
                      />
                       
<Route
                        path={RouteConstant.OilProductionSummaryReport}
                        element={<OilProductionSummaryReport />}
                      />
 {/* <Route 
      //                   path={RouteConstant.OilProductionSummaryReport}
      //                   element={<OilProductionSummaryReport data={[]} // or some default state
      // setLoading={() => {}} / >}
      //                 /> 
                      {/* <Route
                        path={RouteConstant.oilProductiondatatable2}
                        element={<OilProductionDataTable2 data={[]} // or some default state
      setLoading={() => {}} / >}
                      /> */}
                      <Route
                        path={RouteConstant.desiriUsers}
                        element={<DesiriUsers />}
                      />
                      <Route
                        path={RouteConstant.desiriBulls}
                        element={<DesiriBulls/>}
                      />
                      <Route
                        path={RouteConstant.desiriGaana}
                        element={<DesiriGaana/>}
                      />
                      <Route
                        path={RouteConstant.desiriRoles}
                        element={<DesiriRoles/>}
                      />
                    </Route>
                  </Route>
                  <Route
                    element={<PrivateRoute isAuthenticationRequired={false} />}
                  >
                    <Route
                      path={RouteConstant.resetPassword}
                      element={<UserPassword isResetPasswordPage={true} />}
                    />
                    <Route path={RouteConstant.login} element={<SignIn />} />
                    <Route
                      path={RouteConstant.forgotPassword}
                      element={<ForgotPassword />}
                    />
                    <Route
                      path={RouteConstant.register}
                      element={<Register hideAdminModal={emptyFunction} />}
                    />
                  </Route>
                  <Route element={<Layout />}>
                    <Route
                      path={RouteConstant.products}
                      element={<Products />}
                    />
                    <Route
                      path={RouteConstant.viewAllProducts}
                      element={<ViewAllProducts />}
                    />
                    <Route path={RouteConstant.basket} element={<Cart />} />
                    <Route
                      path={RouteConstant.productDetail}
                      element={<ProductDetail />}
                    />
                    <Route
                      path={RouteConstant.viewAllRouteCodes}
                      element={<ViewAllRouteCodes />}
                    />
                    <Route
                      path={RouteConstant.RawMaterialsPurchase}
                      element={<RawMaterialPurchaseForm />}
                    />
                    
                    <Route
                      path={RouteConstant.RawMaterialsPurchasedatatable}
                      element={<RawMaterialsPage />}
                    />
                    <Route
                      path={RouteConstant.viewCountry}
                      element={<ViewAllCountry />}
                    />
                    <Route
                      path={RouteConstant.newAreaPincode}
                      element={<AddAreaPincodeMain />}
                    />
                    <Route
                      path={RouteConstant.addSubdistrict}
                      element={<AddSubdistrict />}
                    />

                    <Route
                      path={RouteConstant.ViewAllStates}
                      element={<ViewAllStates />}
                    />
                    <Route
                      path={RouteConstant.ViewAllCity}
                      element={<ViewAllCity />}
                    />
                    <Route
                      path={RouteConstant.ViewAllCity}
                      element={<ViewAllCity />}
                    />
                    <Route
                      path={RouteConstant.ViewAllCategory}
                      element={<ViewAllCategory />}
                    />
                    <Route
                      path={RouteConstant.ViewAllSubCategory}
                      element={<ViewAllSubCategory />}
                    />
                    <Route
                      path={RouteConstant.privacyPolicy}
                      element={<Privacy />}
                    />
                    <Route
                      path={RouteConstant.shippingPolicy}
                      element={<ShippingPolicy />}
                    />
                    <Route
                      path={RouteConstant.addDistrict}
                      element={<AddDistrict />}
                    />
                    <Route
                      path={RouteConstant.contactUs}
                      element={<ContactUs />}
                    />
                    <Route
                      path={RouteConstant.viewAllCategories}
                      element={<ViewAllCategories />}
                    />
                    <Route
                      path={RouteConstant.ComplaintType}
                      element={<Typedetails1 />}
                    />
                    <Route
                      path={RouteConstant.ViewAllComplaints}
                      element={<Typedetails />}
                    />
                    <Route
                      path={RouteConstant.InternalComplaints}
                      element={<InternalComplaint isUpdate={false} handleOnSuccess={function (): void {
                        throw new Error("Function not implemented.");
                      } } updateComplaintInfo={undefined} AddedData={undefined}/>}
                    />
                    <Route 
                      path={RouteConstant.ComplaintRegisters}
                      element={<ComplaintRegister isUpdate={false} handleOnSuccess={function (): void {
                        throw new Error("Function not implemented.");
                      } } updateComplaintInfo={undefined}/>}
                    />
                    <Route
                      path={RouteConstant.ComplaintMain}
                      element={<ComplaintMain />}
                    />
                    <Route
                      path={RouteConstant.ComplaintActionMain}
                      element={<ComplaintActionMain />}
                    />
                     <Route
                      path={RouteConstant.InternalComplaintRegister}
                      element={<InternalComplaintRegister />}
                    />
                    <Route
                      path={RouteConstant.InternalComplaintMain}
                      element={<InternalComplaintMain />}
                    />
                    <Route
                      path={RouteConstant.InternalComplaintActionMain}
                      element={<InternalComplaintActionMain />}
                    />
                    <Route
                      path={RouteConstant.termsAndConditions}
                      element={<TermsAndConditions />}
                    />
                    <Route
                      path={RouteConstant.returnPolicy}
                      element={<ReturnPolicy />}
                    />
                    <Route
                      path={RouteConstant.registerTermsAndConditions}
                      element={<RegisterTermsAndConditions />}
                    />
                    <Route
                      path={RouteConstant.canceledOrders}
                      element={<CanceledOrderMain />}
                    />

                    <Route
                      path={RouteConstant.newinvoice}
                      element={<NewInvoiceList />}
                    />
                    <Route
                      path={RouteConstant.addState}
                      element={<AddState />}
                    />
                    <Route
                      path={RouteConstant.NewCountry}
                      element={<Countrydis />}
                    />
                    <Route
                      path={RouteConstant.ComplaintType}
                      element={<Typedetails1 />}
                    />
                    <Route
                      path={RouteConstant.viewAllCategories}
                      element={<Categorydetails />}
                    />
                    <Route
                      path={RouteConstant.ViewAllStatus}
                      element={<ViewStatus />}
                    />
                    <Route
                      path={RouteConstant.customerReports}
                      element={<CustomerReportMain/>}
                    />
                    <Route
                      path={RouteConstant.RoleAssignment}
                      element={<RoleAccessmain/>}
                    />
                    <Route
                      path={RouteConstant.FeatureAccessAssign}
                      element={<FeatureAccessMain/>}
                    />
                    <Route
                      path={RouteConstant.CreatingRole}
                      element={<RoleManagement/>}
                    />
                    <Route
                    path={RouteConstant.customerFollowUpReport}
                    element={<CustomerFollowUpMain/>}
                    />
                   
                    <Route
                      path={RouteConstant.deliveryDetails}
                      element={<DeliveryDetailsDatatable/>}
                    />
                    <Route
                    path={RouteConstant.deliveryAnalysis}
                    element={<DeliveryAnalysis/>}
                    />
                    <Route
                    path={RouteConstant.deliveryAddress}
                    element={<DeliveryAddress/>}
                    />
                  </Route>
                  <Route element={<Layout/>}>
                    <Route
                     path={RouteConstant.cashDeposite}
                     element={<Cashdeposite/>}>
                    </Route>
                    <Route
                     path={RouteConstant.gstSalesReports}
                     element={<POSTargetMappingList/>}>
                    </Route>
                       <Route
                     path={RouteConstant.PerformanceReportforCE}
                     element={<CECards/>}>
                    </Route>
                       <Route
                     path={RouteConstant.PerformanceReportforCE}
                     element={<CECards/>}>
                    </Route>
                     <Route
                     path={RouteConstant.CustomerExecutiveTargetMapping}
                     element={<CEtargetMappingList/>}>
                    </Route>

                    <Route
                     path={RouteConstant.posReportDetails}
                     element={<TreemapChart/>}>
                    </Route>
                   <Route
                      path={RouteConstant.openorders}
                      element={<OpenOrders />}
                    />
                    <Route
                    path={RouteConstant.positems}
                    element={<Positems />}
                    />
                    <Route
                    path={RouteConstant.posmovements}
                    element={<PosMovementMain />}
                    />
                    <Route
                    path={RouteConstant.posInventoryReport}
                    element={<POSInventoryReport />}
                    />
                    <Route
                    path={RouteConstant.DeliveryCashMain}
                    element={<DeliveryCashMain/>}
                    />
                    <Route
                    path={RouteConstant.ViewRawMaterials}
                    element={<RawMaterialsMainPage/>}
                    />
                    <Route
                    path={RouteConstant.storeCashMain}
                    element={<StoreCashMain />}
                    />
                     <Route
                    path={RouteConstant.CustomerExecutiveSalesReport}
                    element={<SalesReportTables/>}
                    />
                    <Route
                    path={RouteConstant.InvoicedBySalesReport}
                    element={<InvoicedByReportTable/>}
                    />
                    <Route
                    path={RouteConstant.RawMaterialCategories}
                    element={<RawMaterialCategoriesMainPage/>}
                    />
                    <Route
                    path={RouteConstant.CashReportMain}
                    element={<CashReportMain />}
                    />
                     <Route
                    path={RouteConstant.AccountsCashMain}
                    element={<AccountsCashMain/>}
                    />
                    <Route
                    path={RouteConstant.outwardChallan}
                    element={<OutwardChallanMain />}
                    />
                    <Route
                    path={RouteConstant.CEDailyActivityReportModule}
                    element={<CEDailyActivityReport />}
                    />
                    <Route
                    path={RouteConstant.rawmaterialInventory}
                    element={<RawmaterialInventoryMain />}
                    />
                    <Route
                    path={RouteConstant.rawmaterialMovementLog}
                    element={<RawMaterialMovementMain />}
                    />
                    <Route
                    path={RouteConstant.OrderDeliverySummary}
                    element={<OrderDeliveryStatus />}
                    />
                    <Route
                    path={RouteConstant.ViewAllChallan}
                    element={<ViewAllChallanPage />}
                    />
                     <Route
                    path={RouteConstant.DeliveryExecutivePerformance}
                    element={<DeliveryExecutivePerformance />}
                    />
                       <Route
                    path={RouteConstant.RawMaterailsReport}
                    element={<RawMaterialReport />}
                    />
                      <Route
                    path={RouteConstant.RawMaterialHistory}
                    element={<RawMaterialHistoryMain />}
                    />
                    <Route
                    path={RouteConstant.AddVehicle}
                    element={<VehicleList />}
                    />
                    <Route 
                    path={RouteConstant.BullStatistics} 
                    element={<BullStatistics />} />
                    </Route>
                </Routes>
              </Suspense>
            </LayoutProvider>
          </PermissionsProvider>
        </PrimeReactProvider>
      </Router>
    </>
  );
}

export default App;
